import React, { useEffect, useState } from "react";
import "./App.css";
import Login from "./components/login";
import LoginPassword from "./components/loginpw";
import OAuthCallback from "./components/oauthCallback";
import {
  BrowserRouter,
  Navigate,
  Outlet,
  Route,
  Routes,
  useLocation,
} from "react-router-dom";
import { AuthProvider, useAuthContext } from "./lib/authLib";
import Dashboard from "./components/dashboard";
import Navbar from "./components/navbar";
import Users from "./components/users";
import Billing from "./components/billing";
import Utilities from "./components/utilities";
import UserDetail from "./components/userDetail";
import LogoutButton from "./components/logoutButton";
import Rules from "./components/rules";
import Messages from "./components/messages";
import Charities from "./components/charities";
import Settings from "./components/settings";
import Admin from "./components/admin";
import { SnackbarProvider } from "./contexts/SnackbarContext";
import AdminRoute from "./components/AdminRoute";
import Signup from "./components/signup";
import NotFound from "./components/notFound";
import Terms from "./components/terms";
import Privacy from "./components/privacy";

//This is for pages you must be logged in for. We redirect you to login
const AuthenticationRequired = () => {
  const location = useLocation();
  const { user, loading } = useAuthContext();
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (!loading) {
      setIsLoading(false);
    }
  }, [loading]);

  if (isLoading) {
    return (
      <div
        style={{
          backgroundColor: "#111827", // matches bg-gray-900
          color: "#ffffff", // matches text-white
          height: "100vh",
          width: "100vw",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        Loading...
      </div>
    );
  }
  return user ? (
    <Outlet />
  ) : (
    // include the current location so the user can be redirected after login
    <Navigate to={`/login?redirectTo=${location.pathname}`} />
  );
};

//This is for pages that you can't view if you're already logged in, we redirect you to your dashboard
const NonauthenticationRequired = () => {
  // const location = useLocation();
  const { user } = useAuthContext();
  return user ? <Navigate to={`/users`} /> : <Outlet />;
};

function App() {
  return (
    <AuthProvider>
      <SnackbarProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Navigate replace to="/home" />} />

            <Route path="/terms" element={<Terms />} />
            <Route path="/privacy" element={<Privacy />} />

            {/* STRICTLY PUBLIC PAGES */}
            <Route path="/" element={<NonauthenticationRequired />}>
              <Route path="/signup" element={<Signup />} />
              <Route path="/login" element={<Login />} />
              <Route path="/loginpw" element={<LoginPassword />} />
              <Route path="/auth/google/callback" element={<OAuthCallback />} />
            </Route>

            <Route path="/" element={<AuthenticationRequired />}>
              <Route element={<Navbar />}>
                <Route path="/logout" element={<LogoutButton />} />
                <Route path="/home" element={<Dashboard />} />
                <Route
                  path="/users"
                  element={
                    <AdminRoute>
                      <Users />
                    </AdminRoute>
                  }
                />
                <Route
                  path="/users/:id"
                  element={
                    <AdminRoute>
                      <UserDetail />
                    </AdminRoute>
                  }
                />
                <Route path="/rules" element={<Rules />} />
                <Route path="/messages" element={<Messages />} />
                <Route path="/charities" element={<Charities />} />
                <Route
                  path="/billing"
                  element={
                    <AdminRoute>
                      <Billing />
                    </AdminRoute>
                  }
                />
                <Route
                  path="/utilities"
                  element={
                    <AdminRoute>
                      <Utilities />
                    </AdminRoute>
                  }
                />
                <Route
                  path="/admin"
                  element={
                    <AdminRoute>
                      <Admin />
                    </AdminRoute>
                  }
                />
                <Route path="/settings" element={<Settings />} />
                <Route path="/settings/account" element={<Settings />} />
                <Route path="/settings/inbox/:inboxId" element={<Settings />} />
              </Route>
            </Route>

            <Route path="*" element={<NotFound />} />
          </Routes>
        </BrowserRouter>
      </SnackbarProvider>
    </AuthProvider>
  );
}

export default App;
